<template>
  <div class="card">
    <div class="pb-6 card-header">
      WEBFLEET Details
    </div>
    <div class="p-6 border-t border-b bg-gray-50">
      Ensure the user whose details you enter here has <strong>WEBFLEET.connect API Access</strong>: <br>
      <a href="https://portals.webfleet.com/s/article/How-to-enable-WEBFLEET-connect-access-for-a-WEBFLEET-user?language=en_us" target="_blank">How to enable WEBFLEET.connect access for a WEBFLEET user <fa :icon="['far', 'external-link']" /></a>
    </div>
    <div class="p-6">
      <form @submit.prevent="updateAccount()">
        <fieldset class="form-group">
          <label class="flex items-center form-label">
            <toggle :value.sync="form.integration_webfleet" class="mr-2" />
            Enable WEBFLEET Integration
          </label>
        </fieldset>
        <fieldset class="form-group">
          <label for="webfleet_account" class="form-label">Account</label>
          <input id="webfleet_account" type="text" class="form-input" v-model="form.webfleet_account">
        </fieldset>
        <fieldset class="form-group">
          <label for="webfleet_username" class="form-label">Username</label>
          <input id="webfleet_username" type="text" class="form-input" v-model="form.webfleet_username">
        </fieldset>
        <fieldset class="form-group">
          <label for="webfleet_password" class="form-label">Password</label>
          <input id="webfleet_password" type="password" class="form-input" v-model="form.webfleet_password">
        </fieldset>
        <button type="submit" class="btn btn-primary" v-submitting="submitting">
          Save Details
        </button>
      </form>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'SettingsIntegrations',

    metaInfo: {
      title: 'Integrations Settings'
    },

    created () {
      this.form = JSON.parse(JSON.stringify(this.account))
    },

    computed: {
      ...mapState(['user']),
      ...mapGetters(['account'])
    },

    data () {
      return {
        submitting: false,
        form: {
          integration_webfleet: false,
          webfleet_account: '',
          webfleet_username: '',
          webfleet_password: ''
        }
      }
    },

    methods: {
      async updateAccount () {
        try {
          this.submitting = true
          await this.$api.patch(`account/${this.$route.params.account}/accounts/${this.form.id}`, this.form)
          this.$store.dispatch('syncUser', this)
          this.$toasted.show('Integration Settings Updated')
        } catch (error) {
          console.error(error)
          this.$toasted.error(error.response.data.message)
        } finally {
          this.submitting = false
        }
      }
    }
  }
</script>